import React from 'react';
import { SegmentedControl, type SegmentOption } from '../ui';
import { useTheme, type ThemePreference } from '../../contexts/ThemeContext';

export interface ThemeSwitchProps {
  size?: 'sm' | 'md';
  /** Visually show the "Darstellung" label above the switch (default true). The accessible
   * name is unaffected either way — `SegmentedControl` keeps it via the radiogroup label,
   * just visually hidden when this is false. */
  showLabel?: boolean;
}

const OPTIONS: SegmentOption<ThemePreference>[] = [
  { value: 'light', label: 'Hell' },
  { value: 'dark', label: 'Dunkel' },
  { value: 'system', label: 'System' },
];

/** Three-way Hell/Dunkel/System control, used inside the account menu. */
export const ThemeSwitch: React.FC<ThemeSwitchProps> = ({ size = 'md', showLabel = true }) => {
  const { theme, setTheme } = useTheme();

  return (
    <SegmentedControl
      label="Darstellung"
      showLabel={showLabel}
      fullWidth
      size={size}
      value={theme}
      onChange={setTheme}
      options={OPTIONS}
    />
  );
};
